var minuto_FN = function(){
    minuto = this;
    minuto.init();
};
(function($){

    minuto_FN.prototype = {

    	gadget : null,

    	player : {
            $ : null,
            $title : null,
            $counter : null,
            $date : null,
            $editoriaLabel : null,
            $progress : null,
            duration : null,
            editoria : null,
            initialTop : null,
            timeout : false,
            audio : false
    	},

    	filter : {
			$form : null,
	        $keyword : null,
	        $editoria : null,
	        $order : null,
	        $submit : null,
	        $clear : null,
	        $toggle : null,
	        $floater : null,
	        initialValues : null
    	},

    	$listItems : null,

    	init : () => {

    		minuto.gadget = Utils.getPageWidth() > 660 ? 'desktop' : 'mobile';

            minuto.bindTitles();
            minuto.bindSwiper();
            minuto.bindArchive();
            
            minuto.bindList();
            try { Pager.addCallback( minuto.bindList ) }
            catch( e ){}

        },

        bindList : () => {

        	minuto.$listItems = $( 'audio' );
        	if( !minuto.$listItems.length ) return true;

            const actualizeTime = event => {

                event.target.$ = event.target.$ || $( event.target );
                
                const 
                    data = event.target.$.data( 'minutoList' ),
                    lastTime = Math.round( data._.duration - data._.currentTime )
                ;

                data.$timer.text( minuto.formatTime( lastTime ) );
                
            };

        	const checkAudio = event => {
   
        		event.target.$ = event.target.$ || $( event.target );
        		const data = event.target.$.data( 'minutoList' );

        		if( data !== undefined ){
        			data.$wrapper.first().addClass( 'active' );
        		}
        		
	        };

            const uncheckAudio = event => {
                
                // Atualizando tempo
                event.target.removeEventListener( 'timeupdate', actualizeTime );
  
                // Get data
                event.target.$ = event.target.$ || $( event.target );
                const data = event.target.$.data( 'minutoList' );

                // Uncheck audio
                if( data !== undefined ){

                    data.$wrapper.first().removeClass( 'active' );

                    if( data._.duration === data._.currentTime ){
                        data.$timer.text( minuto.formatTime( data.duration ) );
                    }
                
                }
            
            };

        	minuto.$listItems.each(function(){

        		this.$ = this.$ || $( this );

        		let data = this.$.data( 'minutoList' );
        		if( data === undefined ){

        			data = {
        				_ : this,
        				$ : this.$,
        				$wrapper : this.$.parents( 'li.item-list' ),
        			};

                    data.$title = data.$wrapper.find( '[data-type="title"]' ).first();
                    data.$date = data.$wrapper.find( '[data-type="date"]' ).first();
                    data.$timer = data.$wrapper.find( '.duration' ).first();
                    data.$download = data.$wrapper.find( '.download' ).first();
                    data.duration = data.$timer.data( 'duration' );

        			this.$.data( 'minutoList', data );

                    // Bind title
                    data.$title.on( 'click', (e) => {
                        e.preventDefault();
                        minuto.toggleAudio( data );
                    });

        			// Bind audio events
	                this.addEventListener( 'ended', uncheckAudio );
	                this.addEventListener( 'play', checkAudio );
                    this.addEventListener( 'timeupdate', actualizeTime );

        		}

        	});

        },

        toggleAudio : data => {

            if( data._.paused ){

                if( minuto.player.audio && !data.$.is( minuto.player.audio ) ){
                    minuto.player.audio.pause();
                }

                data._.play();
            
            }
            else {
                data._.pause();
            }

        },

        formatTime : duration => {

            duration = Math.round( duration );

            const 
                hours = Math.floor( duration / 3600 ),
                minutes = Math.floor( ( duration - ( hours * 3600 ) ) / 60 ),
                seconds = duration - ( hours * 3600 ) - ( minutes * 60 )
            ;

            if( hours > 0 ){
                return hours.toString().padStart( 2, '0' ) + ':' + minutes.toString().padStart( 2, '0' ) + ':' + seconds.toString().padStart( 2, '0' );
            }
            else {
                return minutes.toString().padStart( 2, '0' ) + ':' + seconds.toString().padStart( 2, '0' );
            }

        },

        bindTitles : () => {

			// Minuto info text scroll
            $( '.widget-audio,.teaser.minuto' ).each(function(){

                this.$ = this.$ || $( this );

                var data = this.$.data( 'minutoSebrae' );
                if( data === undefined ){

                	data = {
                		_ : this,
	                    $ : this.$,
	                    $info : $( '.minuto-info', this.$ ),
	                    audio : $( 'audio', this.$ ).get(0),
	                    parentAttr : ( this.$.hasClass( 'teaser' ) ? 'right' : 'max-width' )
                	};
                	data.$title = $( '.title', data.$info );
                	data.titleInit = data.$title.outerWidth();

	                // Get percurse hover
	                data.$info.css( data.parentAttr, 'initial' );
	                const titleHover = data.$title.outerWidth();
	                const titlePercurse = titleHover - data.titleInit;
	                data.$info.css( data.parentAttr, '' );

	                const scrollText = () => {
	                    data.$title.css( 'text-indent', ( titlePercurse * -1 ) + 'px' );
	                };
	                const resetText = () => {
	                    data.$title.css( 'text-indent', 0 );
	                };

	                // Set hover
	                if( titlePercurse > 2 ){

	                    if( minuto.isMobile() ){

	                        data.audio.addEventListener( 'ended', resetText );
	                        data.audio.addEventListener( 'pause', resetText );
	                        data.audio.addEventListener( 'play', scrollText );
	                        
	                    }
	                    else {

	                        this.$.hover( scrollText, resetText );

	                    }
	                
	                }

	                // Keep data
                	data.$.data( 'minutoSebrae', data );

                }
            
            });

        },

        bindSwiper : () => {

            // Home
            const $minuto = $( '#minuto-sebrae' );
            if( $minuto.length ){

                const vpWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                if( vpWidth <= 740 ){

                    $minSlider = $( '.swiper', $minuto );
                    $minPager = $( '.swiper-pagination', $minuto );

                    // Initing swiper
                    const __swiper = new Swiper( $minSlider.get(0), {
                        slidesPerView: 1,
                        spaceBetween: 16,
                        mousewheel: {
                            forceToAxis: true
                        },
                        pagination: { 
                            el: $minPager.get( 0 ),
                            clickable: true
                        }
                    });

                }

            }

    	},

    	bindArchive : () => {
            
            // List float
            minuto.$list = $( '.list-minuto' );
            if( minuto.$list.length ){

                // Elements
                minuto.player.$ = $( '.player-floater' );
                minuto.player.$title = $( '[data-type="title"]', minuto.player.$ ).first();
                minuto.player.$date = $( '[data-type="date"]', minuto.player.$ ).first();
                minuto.player.$download = $( '[data-action="download"]', minuto.player.$ ).first();
                minuto.player.$counter = $( '[data-type="counter"]', minuto.player.$ ).first();
                minuto.player.$duration = $( '[data-type="duration"]', minuto.player.$ ).first();
                minuto.player.$participante = $( '[data-type="participante"]', minuto.player.$ ).first();
                minuto.player.$editoriaLabel = $( '[data-type="editoria-label"]', minuto.player.$ ).first();
                minuto.player.$progress = $( '[data-type="progress"]', minuto.player.$ ).first();
                minuto.player.$tagsList = $( '[data-type="tags-list"]', minuto.player.$ ).first();
                minuto.player.$pause = $( 'button[data-action="pause"]', minuto.player.$ ).first();
                minuto.player.$prev = $( 'button[data-action="prev-audio"]', minuto.player.$ ).first();
                minuto.player.$next = $( 'button[data-action="next-audio"]', minuto.player.$ ).first();
                minuto.player.initialTop = minuto.player.$.offset().top;

                // Binds
                minuto.player.$pause.on( 'click', event => {
                    event.preventDefault();
                    minuto.player.audio.pause();
                });
                minuto.player.$next.on( 'click', event => {
                    event.preventDefault();
                    minuto.playAudioList( 'next' );
                });
                minuto.player.$prev.on( 'click', event => {
                    event.preventDefault();
                    minuto.playAudioList( 'prev' );
                });

                // Bind floater audios
                minuto.bindFloaterAudios();
                try { Pager.addCallback( minuto.bindFloaterAudios ) }
                catch( e ){}

                // Bind filters
                minuto.bindFilters();

            }
       
    	},

    	bindFilters : () => {

			// Bind filters
            minuto.filter.$form = $( '#filter-minuto' );
            minuto.filter.$keyword = $( 'input[name="buscar-por"]', minuto.filter.$form );
            minuto.filter.$submit = $( 'button[data-action="submit"]', minuto.filter.$form );
            minuto.filter.$clear = $( 'button[data-action="clear-keyword"]', minuto.filter.$form );
            minuto.filter.$floater = minuto.filter.$form.children( 'fieldset' ).first();
            minuto.filter.$open = $( 'button.toggle-filters', minuto.filter.$form );
            minuto.filter.$close = $( 'button[ data-action="close-floater"]', minuto.filter.$form );
	        minuto.filter.$editoriaHidden = $( '.mobile input[name="editorias"]', minuto.filter.$form );
            
            // Editoria e order
            if( minuto.gadget === 'desktop' ){

	            minuto.filter.$editoria = $( '.desktop input[name="editoria"]', minuto.filter.$form );
	            minuto.filter.$order = $( '.desktop input[name="ordenar-por"]', minuto.filter.$form );
            
                $( 'div.mobile', minuto.filter.$form ).remove();

            }
            else {
	        
                minuto.filter.$editoria = $( '.mobile input[data-machine-name="editorias"]', minuto.filter.$form );
	            minuto.filter.$order = $( '.mobile input[data-machine-name="ordem"]', minuto.filter.$form );

                $( 'div.desktop', minuto.filter.$form ).remove();
               
            }

            // Initial values
			minuto.filter.initialValues = minuto.extractFilters();

            // Form submit
            minuto.filter.$form.on( 'submit.Minuto', function(e){
                var doSubmit = minuto.filter.$form.data( 'doSubmit' );
                if( doSubmit !== undefined && doSubmit === true ){
                    return true;
                }
                else {
                    e.preventDefault();
                    minuto.validateFilters();
                }
            });

            // Submit
            minuto.filter.$submit.on( 'click', () => { minuto.filter.$form.submit() });

            // Check filters
            minuto.filter.$keyword.on('keyup', minuto.checkFilters );
            minuto.filter.$editoria.on('change', minuto.checkFilters );
            minuto.filter.$order.on('change', minuto.checkFilters );

            // Clear button
            minuto.filter.$clear.on( 'click', function(){
                minuto.filter.$keyword.val( '' );
                minuto.filter.$form.data( 'doSubmit', true );
                minuto.filter.$form.submit();
            });

            // Mobile
            minuto.filter.$open.on( 'click', event => {
            	event.preventDefault();
            	asn.lockScroll();
            	minuto.filter.$floater.addClass( 'opened' );
            });
            minuto.filter.$close.on( 'click', event => {
            	event.preventDefault();
            	asn.unlockScroll();
            	minuto.filter.$floater.removeClass( 'opened' );
            });
    	},

    	extractFilters : () => {

    		const 
    			$order = minuto.filter.$order.filter( ':checked' ),
    			$editoria = minuto.filter.$editoria.filter( ':checked' )
    		;

    		// Editorias
    		let editoria = '';
    		if( $editoria.length ){
    			if( $editoria.length > 1 ){
    				editoria = [];
    				$editoria.each(function(){
    					editoria.push( this.value );
    				});
    				editoria = editoria.join(',');
    			}
    			else {
    				editoria = $editoria.val();
    			}
    		}
    		
    		const values = {
    			keyword : minuto.filter.$keyword.val(),
    			editoria : editoria,
    			order : $order.length ? $order.val() : '',
    		};

    		return values;
    	
    	},

    	checkFilters : () => {

    		const filters = minuto.extractFilters();

    		let isInitial = true;
    		Object.keys( filters ).forEach( key => {
    			if( filters[ key ] !== minuto.filter.initialValues[ key ] ){
    				isInitial = false;
    			}
    		});

    		// Keyword value
    		const keyword = minuto.filter.$keyword.val();

    		// Submit button
    		if( isInitial || ( keyword !== '' && keyword.length < 3 ) ){
    			minuto.filter.$submit.prop( 'disabled', true );
    		}
    		else {
    			minuto.filter.$submit.prop( 'disabled', false );
    		}

    		// Clear button
    		if( keyword === '' ){
    			minuto.filter.$clear.fadeOut();
    		}
    		else {
				minuto.filter.$clear.fadeIn();
    		}

    	},

    	validateFilters : () => {

    		var keyword = minuto.filter.$keyword.val();
    		if( keyword === '' || keyword.length > 2 ){

    			// Remove empty fields
    			const values = minuto.extractFilters();

    			// Keyword
    			if( values.keyword === '' ){
    				minuto.filter.$keyword.removeAttr( 'name' );
    			}

    			// Order
    			if( values.order === '' || values.order === 'mais-recentes' ){
    				minuto.filter.$order.removeAttr( 'name' );
    			}

    			// Editorias
    			if( minuto.gadget === 'mobile' ){
		        
		            if( values.editoria !== '' ){
		            	minuto.filter.$editoriaHidden.val( values.editoria );
		            }
		            else {
						minuto.filter.$editoriaHidden.removeAttr( 'name' );
		            }
		            minuto.filter.$editoria.removeAttr( 'name' );

	            }

    			// Do Submit
    			minuto.filter.$form.data( 'doSubmit', true );
                minuto.filter.$form.submit();
    		
    		}
    	
    	},

        playAudioList : ( sentido ) => {

            const $audios = $( '.list-minuto audio' );
            let 
                nextIndex = 0,
                nextAudio = false
            ;

            // Search next index
            $audios.each(function( index ){
                this.$ = this.$ || $( this );
                if( this.$.is( minuto.player.audio ) ){
                    nextIndex = sentido === 'next' ? ( index + 1 ) : ( index - 1 );
                }
            });

            // Get next audio element
            if( sentido === 'next' && nextIndex >= $audios.length ){
            	nextIndex = 0;
            }
            else if( sentido === 'prev' && nextIndex < 0 ){
            	nextIndex = $audios.length - 1;
            }

            // Play next
            nextAudio = $audios.get( nextIndex );
            minuto.player.audio.pause();
            nextAudio.play();
            
        },

        bindFloaterAudios : () => {
            
            $( 'audio' ).each(function(){

            	this.$ = this.$ || $( this );

            	// Just once
            	if( this.$.data( 'minutoSebrae' ) !== undefined ) return true;

            	// Bind play
                this.addEventListener( 'play', () => {

                    const bindEnded = this.addEventListener( 'ended', minuto.hidePlayer );
                    const bindUpdated = this.addEventListener( 'timeupdate', minuto.setPlayerProgress );

                    // On pause
                    const pauseEvent = this.addEventListener( 'pause', event => { 

                        minuto.hidePlayer();

                        this.removeEventListener( 'ended', bindEnded );
                        this.removeEventListener( 'timeupdate', bindUpdated );
                        this.removeEventListener( 'pause', pauseEvent );

                    });
                    
                    minuto.showPlayer( this );
                
                });

                // Keep data
                this.$.data( 'minutoSebrae', true );

            });

        },

        showPlayer : audio => {

            audio.$ = audio.$ || $( audio );

            // Timeout
            const actualTop = minuto.player.$.offset().top;
            const timeDuration = actualTop === minuto.player.initialTop ? 0 : 200;

            // Hide player
            minuto.player.$.removeClass( 'showing' );

            // Timeout to change player metadata
            if( minuto.player.timeout ) clearTimeout( minuto.player.timeout );
            minuto.player.timeout = setTimeout(() => {


                let data = audio.$.data( 'playerFloater' );
                if( data === undefined ){
                    data = {
                        _ : audio,
                        $ : audio.$,
                        $widget = audio.$.parents( '.widget-audio,.item-list' ).first()
                    };
                    data.editoria = data.$widget.data( 'editoria' );
                    data.editoriaLabel = data.$widget.data( 'editoria-label' );
                    data.title = data.$widget.find( '[data-type="title"]' ).first().text();
                    data.date = data.$widget.find( '[data-type="date"]' ).first().text();
                    data.counter = data.$widget.find( '[data-type="counter"]' ).first().text();
                    data.duration = data.$widget.find( '[data-type="duration"]' ).first().text();
                    data.download = data.$widget.find( '.download' ).first().attr( 'href' );
                    data.participante = data.$widget.find( '[data-type="participante"]' ).first().text();
                    data.$tags = data.$widget.find( '[data-type="tags-list"]' ).first().children( 'li' );
                }

                // Set player data
                minuto.player.$title.text( data.title );
                minuto.player.$download.attr( 'href', data.download );
                minuto.player.$date.text( data.date );
                minuto.player.$counter.text( data.counter );
                minuto.player.$participante.text( data.participante );
                minuto.player.$duration.text( data.duration );
                minuto.player.$editoriaLabel.text( data.editoriaLabel );
                minuto.player.audio = audio;
                
                // Tags
                minuto.player.$tagsList.find( 'li' ).remove();
                if( data.$tags.length ){
                    data.$tags.clone().appendTo( minuto.player.$tagsList );
                }

                // Show player
                minuto.player.$
                    .attr( 'class', 'player-floater' )
                    .addClass( data.editoria )
                    .addClass( 'showing' )
                ;

            }, timeDuration );

        },

        hidePlayer : () => {
            minuto.player.$.removeClass( 'showing' );
        },

        setPlayerProgress : event => {

            // Bar
            const newSize = event.target.currentTime * 100 / event.target.duration;
            minuto.player.$progress.css( 'width', newSize + '%' );

            // Timer
            const newTime = Math.round( event.target.duration - event.target.currentTime );
            minuto.player.$duration.text( minuto.formatTime( newTime ) );
        
        },

        isMobile : function(){
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }

    };
	   
	window.addEventListener( 'load', function(){
        minuto = new minuto_FN();
    });

})(jQuery);